// extracted by mini-css-extract-plugin
module.exports = {"Main":"styles_Main__1Uu1C","Main-content":"styles_Main-content__1ot9f"};